// @ts-nocheck
import React from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

function AllowSubdivisionForm({
  automation,
  onAutomationChange,
  classes
}) {
  const { t } = useTranslation();

  const handleToggle = (e) => {
    onAutomationChange({
      ...automation,
      allowPakSubdivision: e.target.checked,
    });
  };

  return (
    <FormControlLabel
      classes={{
        root: classes.switchContainer,
        label: classes.switchLabel,
      }}
      labelPlacement="start"
      control={
        <Switch
          checked={!!automation.allowPakSubdivision}
          onChange={handleToggle}
          name="allowPakSubdivision"
        />
      }
      label={t('processTypes.allowSubdivision_form.labels.allowSubdivision')}
    />
  );
}

export default AllowSubdivisionForm;